/* eslint-disable */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import handleZoom from "utils/handleZoom";

// [
//   "NAME",
//   "MIN_PLOT_AREA",
//   "MIN_FRONTAGE_WIDTH",
//   "FLOOR_NO",
//   "MAX_HEIGHT",
//   "REMARK", --
//   "FLOOR_AREA_RATIO",
//   "BUILT_UP_AREA_PERCENT",
//   "SETBACK_FRONT",
//   "SETBACK_SIDE",
//   "SETBACK_BACK",
// ];
function ParcelLaws(props) {
  const {
    law,
    graphicsLayer,
    dataToZoom,
    view,
    methods,
    disabled,
    extraZoomFunc,
    showName,
    lawToCompare,
  } = props;
  
  const {
    register,
    setValue,
    formState: { errors },
  } = methods;

  const [lawKeysToFocus, setLawKeysToFocus] = useState([]);

  useEffect(() => {
    if ((law, methods)) {
      const tempLaw = { ...law };
      delete tempLaw.parcels;
      if (lawToCompare) {
        const initLawKeysToFocus = Object.keys(lawToCompare).filter(
          (key) => law[key] !== lawToCompare[key]
        );
        setLawKeysToFocus(initLawKeysToFocus);
      }

      Object.entries(tempLaw).map(([key, value]) => setValue(key, value));
    }
  }, [law, methods]);

  return (
    <>
      {/* {dataToZoom && (
        <button
          type="button"
          // disabled={disabled}
          className="btn btn--primary mb-3"
          onClick={() => {
            handleZoom(dataToZoom, view, graphicsLayer, {
              color: [11, 250, 47, 1],
              width: 2,
            });
            extraZoomFunc();
          }}
        >
          تحديد
        </button>
      )} */}
      {law?.ZONE_ID==12?
      <div style={{textAlign:"center",padding:"2rem"}}>
        منطقة أثار لاتتوفر احكام استعمال   
      </div>:
      <>
            {showName&& (
        <Form.Group className="mb-3 input input-md" controlId="NAME">
          <Form.Label>صفة الاستعمال</Form.Label>
          <Form.Control
            className={`${lawKeysToFocus?.includes("NAME") && "focus"}`}
            autoComplete="off"
            type="text"
            disabled={disabled}
            {...register("NAME", {
              required: "الرجاء ادخال الحقل",
            })}
          />
          {errors.NAME && (
            <Form.Text className="text-danger">{errors.NAME.message}</Form.Text>
          )}
        </Form.Group>
      )}
      <Form.Group className="mb-3 input input-md" controlId="MIN_PLOT_AREA">
        <Form.Label>الحد الأدنى من مساحة الإفراز</Form.Label>
        <Form.Control
          className={`${lawKeysToFocus?.includes("MIN_PLOT_AREA") && "focus"}`}
          autoComplete="off"
          type="number"
          disabled={disabled}
          {...register("MIN_PLOT_AREA", {
            required: "الرجاء ادخال الحقل",
            min: {
              value: 0,
              message: "الرجاء ادخال الحقل",
            },
          })}
        />
        {errors.MIN_PLOT_AREA && (
          <Form.Text className="text-danger">
            {errors.MIN_PLOT_AREA.message}
          </Form.Text>
        )}
      </Form.Group>
      <Form.Group
        className="mb-3 input input-md"
        controlId="MIN_FRONTAGE_WIDTH"
      >
        <Form.Label> الحد الأدنى لعرض الواجهة الأمامية</Form.Label>
        <Form.Control
          className={`${
            lawKeysToFocus?.includes("MIN_FRONTAGE_WIDTH") && "focus"
          }`}
          autoComplete="off"
          type="number"
          disabled={disabled}
          {...register("MIN_FRONTAGE_WIDTH", {
            required: "الرجاء ادخال الحقل",
            min: {
              value: 0,
              message: "الرجاء ادخال الحقل",
            },
          })}
        />
        {errors.MIN_FRONTAGE_WIDTH && (
          <Form.Text className="text-danger">
            {errors.MIN_FRONTAGE_WIDTH.message}
          </Form.Text>
        )}
      </Form.Group>
      <Form.Group className="mb-3 input input-md" controlId="FLOOR_NO">
        <Form.Label>عدد الطوابق</Form.Label>
        <Form.Control
          className={`${lawKeysToFocus?.includes("FLOOR_NO") && "focus"}`}
          autoComplete="off"
          type="text"
          disabled={disabled}
          {...register("FLOOR_NO", {
            required: "الرجاء ادخال الحقل",
          })}
        />
        {errors.FLOOR_NO && (
          <Form.Text className="text-danger">
            {errors.FLOOR_NO.message}
          </Form.Text>
        )}
      </Form.Group>
      <Form.Group className="mb-3 input input-md" controlId="MAX_HEIGHT">
        <Form.Label>الحد الأعلى لإرتفاع البناء</Form.Label>
        <Form.Control
          className={`${lawKeysToFocus?.includes("MAX_HEIGHT") && "focus"}`}
          autoComplete="off"
          type="text"
          disabled={disabled}
          {...register("MAX_HEIGHT", {
            required: "الرجاء ادخال الحقل",
          })}
        />
        {errors.MAX_HEIGHT && (
          <Form.Text className="text-danger">
            {errors.MAX_HEIGHT.message}
          </Form.Text>
        )}
      </Form.Group>
      <Form.Group className="mb-3 input input-md" controlId="FLOOR_AREA_RATIO">
        <Form.Label>النسبة المئوية الطابقية</Form.Label>
        <Form.Control
          className={`${
            lawKeysToFocus?.includes("FLOOR_AREA_RATIO") && "focus"
          }`}
          autoComplete="off"
          type="number"
          disabled={disabled}
          {...register("FLOOR_AREA_RATIO", {
            required: "الرجاء ادخال الحقل",
            min: {
              value: 0,
              message: "الرجاء ادخال الحقل",
            },
          })}
        />
        {errors.FLOOR_AREA_RATIO && (
          <Form.Text className="text-danger">
            {errors.FLOOR_AREA_RATIO.message}
          </Form.Text>
        )}
      </Form.Group>
      <Form.Group
        className="mb-3 input input-md"
        controlId="BUILT_UP_AREA_PERCENT"
      >
        <Form.Label>النسبة المئوية لمساحة البناء</Form.Label>
        <Form.Control
          className={`${
            lawKeysToFocus?.includes("BUILT_UP_AREA_PERCENT") && "focus"
          }`}
          autoComplete="off"
          type="text"
          disabled={disabled}
          {...register("BUILT_UP_AREA_PERCENT", {
            required: "الرجاء ادخال الحقل",
          })}
        />
        {errors.BUILT_UP_AREA_PERCENT && (
          <Form.Text className="text-danger">
            {errors.BUILT_UP_AREA_PERCENT.message}
          </Form.Text>
        )}
      </Form.Group>
      <Form.Group className="mb-3 input input-md" controlId="SETBACK_FRONT">
        <Form.Label>الإرتداد الأمامي</Form.Label>
        <Form.Control
          className={`${lawKeysToFocus?.includes("SETBACK_FRONT") && "focus"}`}
          autoComplete="off"
          type="text"
          disabled={disabled}
          {...register("SETBACK_FRONT", {
            required: "الرجاء ادخال الحقل",
          })}
        />
        {errors.SETBACK_FRONT && (
          <Form.Text className="text-danger">
            {errors.SETBACK_FRONT.message}
          </Form.Text>
        )}
      </Form.Group>
      <Form.Group className="mb-3 input input-md" controlId="SETBACK_SIDE">
        <Form.Label>الإرتداد الجانبي</Form.Label>
        <Form.Control
          className={`${lawKeysToFocus?.includes("SETBACK_SIDE") && "focus"}`}
          autoComplete="off"
          type="text"
          disabled={disabled}
          {...register("SETBACK_SIDE", {
            required: "الرجاء ادخال الحقل",
          })}
        />
        {errors.SETBACK_SIDE && (
          <Form.Text className="text-danger">
            {errors.SETBACK_SIDE.message}
          </Form.Text>
        )}
      </Form.Group>
      <Form.Group className="mb-3 input input-md" controlId="SETBACK_BACK">
        <Form.Label>الإرتداد الخلفي</Form.Label>
        <Form.Control
          className={`${lawKeysToFocus?.includes("SETBACK_BACK") && "focus"}`}
          autoComplete="off"
          type="text"
          disabled={disabled}
          {...register("SETBACK_BACK", {
            required: "الرجاء ادخال الحقل",
          })}
        />
        {errors.SETBACK_BACK && (
          <Form.Text className="text-danger">
            {errors.SETBACK_BACK.message}
          </Form.Text>
        )}
      </Form.Group>

      <Form.Group className="mb-3 input input-md" controlId="REMARK">
        <Form.Label>الملاحظات</Form.Label>
        <Form.Control
          className={`${lawKeysToFocus?.includes("REMARK") && "focus"}`}
          autoComplete="off"
          as="textarea"
          {...register("REMARK", {
            required: "الرجاء ادخال الحقل",
          })}
          disabled={disabled}
        />
        {errors.REMARK && (
          <Form.Text className="text-danger">{errors.REMARK.message}</Form.Text>
        )}
      </Form.Group>

      </>}
      
    </>
  );
}
ParcelLaws.defaultProps = {
  law: {},
  lawToCompare: null,
  graphicsLayer: null,
  dataToZoom: null,
  view: null,
  methods: {
    register: () => {},
    setValue: () => {},
    formState: { errors: {} },
  },
  disabled: false,
  showName: true,
  extraZoomFunc: () => {},
};

ParcelLaws.propTypes = {
  law: PropTypes.object,
  lawToCompare: PropTypes.object,
  graphicsLayer: PropTypes.object,
  dataToZoom: PropTypes.array,
  view: PropTypes.object,
  methods: PropTypes.object,
  disabled: PropTypes.bool,
  showName: PropTypes.bool,
  extraZoomFunc: PropTypes.func,
};
export default ParcelLaws;
